const C = require("../constants");
const initial_data = {open: false, product:{id:null, name:'',}};

function ProductRecipesDialogReducer(state = initial_data, action) {
    switch (action.type) {
        case C.PRODUCT_RECIPES_DIALOG:
            return action.data;
        default:
            return state;
    }
}

export default ProductRecipesDialogReducer;


// WEBPACK FOOTER //
// ./src/reducers/ProductRecipesDialogReducer.js